<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">Our Mascot Kimba</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>/
                        <li class="active">
                            <a routerLink="/kimba">Our Mascot Kimba</a>
                        </li>
                    </ul>
                    <div class="kimba-bg">
                        <img src="{{baseUrl}}/kimba/kimba.webp" alt="Kimba | GHRCACS, PUNE" title="Kimba | GHRCACS, PUNE">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="about-area ptb--100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="abt-left-content text-justify">
                    <div class="section-title">
                        <h4>Welcome Raisonians – </h4>
                        <h2><span>Come, Meet Your Friend Kimba</span></h2>
                    </div>
                    <p>Welcome to a promising world of literacy, knowledge, and development – Welcome to RGI! We do
                        understand that the first step is always hard because it brings along a whole new world of
                        unknown elements, people, and environment. Within this novel, unfamiliar, and exotic premises,
                        you are bound to get lost, you are bound to feel lonely. But, you have to take that first step!
                    </p>

                    <p>Thinking about innovative, creative, and exemplary ways of making your first step into RGI most
                        memorable, here we present ‘Kimba – Our Mascot, Your Friend’.</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="text-center">
                    <img src="{{baseUrl}}/kimba/kimba-1.webp" alt="kimba | GHRCACS, PUNE" title="kimba | GHRCACS, PUNE" width="160px">

                </div>
            </div>
        </div>
    </div>
</section>
<section class="bg-blue ptb--100">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-lg-6">
                <div class="about-sev-img">
                    <div class="lightBox--gallery mascot-video">
                        <div class="overlay-effect--2"></div>
                        <ul id="video-gallery">
                            <li class="video" data-src="https://www.youtube.com/embed/_SUmhzkNq6U"
                                data-poster="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/kimba/video-img.webp"
                                data-aos="fade-up">
                                <a href="https://www.youtube.com/embed/_SUmhzkNq6U">
                                    <img class="img-responsive img-mascot img-fluid"
                                        src="{{baseUrl}}/kimba/video-img.webp" alt="About kimba | GHRCACS, PUNE" title="About Kimba | GHRCACS, PUNE">
                                    <div class="light-gallery-poster">
                                        <img src="{{baseUrl}}/play-button.webp" alt="GHRCACS, PUNE">
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="abt-left-content text-justify">
                    <div class="section-title">
                        <h4>Introducing</h4>
                        <h2><span> Our Mascot</span></h2>
                    </div>
                    <p>With the introduction of Kimba, RGI becomes a pioneer educational institution in India to launch
                        the concept of a Mascot.</p>
                    <p>Etymologically, a mascot is a term originated from the French word, 'Mascotte' that means ‘Lucky
                        Charm’. The first record of the term was mentioned in the comic operetta ‘La Mascotte’ performed
                        by a French composer Edmond Audran in December 1880. The succeeding year, the term made its
                        space in the English Language and from there it has travelled a long and meaningful way across
                        diversified parameters of life.</p>
                    <p>Talking about the concept, we too at RGI started to feel that mascots can help us represent our
                        educational institution with more love and awareness while helping build deeper relationships.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="sec-kimba ptb--100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="abt-left-content text-justify">
                    <div class="section-title">
                        <h4 class="text-white">Why</h4>
                        <h2><span> Kimba</span></h2>
                    </div>
                    <div class="text-justify text-white">
                        <p class=" text-white">Understanding the concept, the significance mascot branding comes to
                            limelight. And we went deeper into the emotional, physiological, and spiritual core of the
                            age-old and time-tested group of institutions, RGI.</p>

                        <p class=" text-white">Here, the challenge was to have a mascot that can be relatable to the
                            age, functioning, strengths, weaknesses, likes, dislikes, and milestones of RGI.</p>

                        <p class=" text-white">When we talk about a lion, we know the lion takes a different direction
                            and is courageous enough to defend for his life and territory. RGI has also followed the
                            same approach and strategy while navigating the course of its journey with all the soft and
                            hard waves. The group was never hesitant to innovate, to have a risk tolerance, and to tread
                            towards a completely different direction.</p>
                        <p class=" text-white">We are also aware that a lion is a social animal and loves to take
                            everyone together. RGI also stands as an epitome of togetherness across demographics,
                            similar to a vast sea with many rivers and streams feeding it with energy, dynamism, values,
                            and wisdom. In return, being fed with pride, honor, and reputation it has gained over the
                            years.</p>

                        <p class=" text-white">When we talk about age, strength, leadership, and courage RGI has
                            portrayed through its rich legacy, what can be a better option than a ‘Lion Mascot’
                            showcasing the attributes of maturity, courage, determination, strength, and leadership.
                            It’s like following the preaching of Osho, “Come out of the masses. Stand like a lion and
                            live your life according to your own light”. So, comes the Lion with the name Kimba!</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="sticker-kimba">
        <img src="{{baseUrl}}/kimba/kimb-sticker2.webp" alt="kimba | GHRCACS, PUNE" class="img-fluid">
    </div>
</section>
<section class="about-area ptb--100">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col-lg-3">
                <img src="{{baseUrl}}/kimba/kimb-sticker.webp" alt="kimba | GHRCACS, PUNE" title="kimba | GHRCACS, PUN">
            </div>
            <div class="col-lg-9">
                <div class="abt-left-content text-justify">
                    <div class="section-title">
                        <h4>Connecting </h4>
                        <h2><span>with Kimba</span></h2>
                    </div>
                    <p>Making the students of RGI connect with Kimba is like instilling relationships and a sense of
                        belongingness in a lot of traditions. You enter the campus and your friend Kimba awaits to wave
                        you, be your friend, and comfort your first step into a world unknown. He is a lovable, brave,
                        and totally huggable guy with a quirky and intelligent bundle of attributes displaying through
                        his infectious smile.</p>
                    <p>Kimba stands with you to nurture and respect life, he is there to be your strength when required
                        to be serious for studies, he is there to hit the football on the ground, and full of energy he
                        stays around you as a cheerleader to convert your bad day to a good day. You name him, and he
                        comes to you with a bundle of smiles, excitement, and joy as you walk your learning journey.</p>
                    <blockquote>Kimba, your friend, is awaiting to go on pawsome adventures with you at RGI!
                    </blockquote>
                    <blockquote class="blockquote-div">
                        <p>Kimba, your friend, is awaiting to go on pawsome adventures with you at RGI!</p>
                    </blockquote>
                </div>
            </div>
        </div>
    </div>
</section>
